// =====================================================================================
// FILE: src/utils/categoryUtils.js (FIXED FOR DYNAMIC CATEGORIES)
// =====================================================================================

/**
 * Normalize a string for comparison (lowercase, trim, collapse whitespace)
 */
export function norm(s) {
  return String(s || "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, " ");
}

/**
 * Find the canonical category name from an array of allowed categories
 * Returns the first match or null if not found
 */
export function canonicalCategory(input, allowedCategories) {
  // ✅ FIXED: Handle null/undefined allowedCategories
  if (!allowedCategories || !Array.isArray(allowedCategories)) {
    return String(input || "").trim() || null;
  }
  
  const needle = norm(input);
  if (!needle) return null;
  
  for (const allowed of allowedCategories) {
    if (norm(allowed) === needle) return allowed;
  }
  return null;
}

/**
 * Create a Set of normalized category names for quick lookup
 */
export function makeAllowedSet(categories) {
  // ✅ FIXED: Handle null/undefined categories
  if (!categories || !Array.isArray(categories)) {
    return new Set();
  }
  
  return new Set(categories.map(norm));
}

/**
 * Remove duplicates from an array (case-insensitive)
 */
export function uniqArr(arr) {
  if (!Array.isArray(arr)) return [];
  
  const seen = new Set();
  const result = [];
  
  for (const item of arr) {
    const normalized = norm(item);
    if (normalized && !seen.has(normalized)) {
      seen.add(normalized);
      result.push(item);
    }
  }
  
  return result;
}

/**
 * Clean up a multi-select array: remove empty strings, duplicates
 */
export function cleanMulti(arr) {
  if (!Array.isArray(arr)) return [];
  
  return uniqArr(
    arr
      .map((s) => String(s || "").trim())
      .filter(Boolean)
  );
}
